import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';
import { Modal, Typography } from '@orijinworks/frontend-commons';

/** Shown when GET /api/content/form/:id returns 204 (form disabled). */
export const INACTIVE_FORM_ATTACHMENT_MESSAGE = 'The form is no longer active.';

/**
 * @param {{ open: boolean, onClose: () => void }} props
 */
const InactiveFormAttachmentModal = ({ open, onClose }) => (
  <Modal
    open={open}
    Icon={<ErrorOutlineIcon aria-hidden />}
    actionBtnText="OK"
    cancelBtnText="Close"
    describedBy="inactive-form-attachment-modal-body"
    heading="Unable to open form"
    isSnackBarShown={false}
    labelledBy="inactive-form-attachment-modal-title"
    modalType={{ type: 'confirmation', status: 'danger', size: 'medium' }}
    styles={{
      mainWrapperStyles: { height: 'auto' },
    }}
    onClose={onClose}
    onContinue={onClose}
  >
    <div id="inactive-form-attachment-modal-body">
      <Typography variant="body1">{INACTIVE_FORM_ATTACHMENT_MESSAGE}</Typography>
    </div>
  </Modal>
);

export default InactiveFormAttachmentModal;
